(() => {
  const backorderVendors = [
    "Clay Imports Breeze Block",
    "Clay Imports Clay Production",
    "Clay Imports Hecho a Mano",
    "Clay Imports Organic Paver",
    "Clay Imports Organic Terracotta",
    "Clay Imports Organic Tile",
    "Clay Imports Paver",
    "Clay Imports Pressed Terracotta Tile",
    "Clay Imports Printed",
    "Clay Imports Solid Tile",
    "Clay Imports Terracotta Tile"
  ];

  function init() {
    const submitBtn    = document.querySelector('.js-product-calculator-atc');
    const labelSpan    = submitBtn?.querySelector('.js-product-calculator-atc-text');
    const sqftInput    = document.querySelector('.js-product-calculator-input[data-type="sqft"]');
    const variantInput = document.querySelector('.js-product-calculator-variant');
    const qtyInput     = document.querySelector('.js-product-calculator-quantity');

    if (!submitBtn || !labelSpan) {
      setTimeout(init, 200);
      return;
    }

    // ── MODAL ───────────────────────────────────────────────────────────────

    function ensureBackorderModal() {
      if (document.getElementById('ci-backorder-popup')) return;

      if (!document.getElementById('ci-backorder-popup-styles')) {
        const css = `
          .ci-pop-overlay {
            position: fixed; inset: 0;
            background: rgba(0, 0, 0, 0.40);
            z-index: 999999;
            display: none; align-items: center; justify-content: center;
          }
          .ci-pop-overlay.is-open {
            display: flex;
            animation: dhanisFadeIn 0.4s ease forwards;
          }
          .ci-pop-overlay.is-closing {
            animation: dhanisFadeOut 0.35s ease forwards;
          }
          @keyframes dhanisFadeIn  { from { opacity: 0; } to { opacity: 1; } }
          @keyframes dhanisFadeOut { from { opacity: 1; } to { opacity: 0; } }

          .ci-pop {
            background: #ffffff;
            border: 1px solid #d6cfc8;
            padding: 36px 40px 32px;
            max-width: 440px;
            width: 90%;
            position: relative;
            animation: dhanisSlideUp 0.45s cubic-bezier(0.22, 1, 0.36, 1) forwards;
            opacity: 0;
            transform: translateY(24px);
          }
          @keyframes dhanisSlideUp {
            from { opacity: 0; transform: translateY(24px); }
            to   { opacity: 1; transform: translateY(0);    }
          }

          .ci-pop__x {
            position: absolute; top: 14px; right: 16px;
            background: none; border: none;
            font-size: 2rem; color: #999999;
            cursor: pointer; line-height: 1; padding: 0;
            font-family: 'Montserrat', sans-serif; min-height: 0;
          }
          .ci-pop__x:hover { color: #333333; }

          .ci-pop__label {
            display: flex; align-items: center;
            font-family: 'Montserrat', sans-serif;
            font-size: 1.1rem; font-weight: 600;
            letter-spacing: 0.12em; text-transform: uppercase;
            color: #C66E4E; margin-bottom: 14px;
          }
          .ci-pop__dot {
            display: inline-block; width: 9px; height: 9px; min-width: 9px;
            background: #C66E4E; border-radius: 50%;
            margin-right: 10px; position: relative;
          }
          .ci-pop__dot::after {
            content: ''; position: absolute; inset: -4px; border-radius: 50%;
            background: rgba(198, 110, 78, 0.20);
            animation: dhanisRipple 2s ease-in-out infinite;
          }
          @keyframes dhanisRipple {
            0%, 100% { transform: scale(1); opacity: 1; }
            50%       { transform: scale(1.6); opacity: 0; }
          }

          .ci-pop__message {
            font-family: 'Montserrat', sans-serif;
            font-size: 1.47rem; color: #1a1a1a;
            line-height: 1.55; margin: 0 0 28px;
          }

          .ci-pop__cta {
            display: block; width: 100%; height: 45px;
            background: #C66E4E; color: #ffffff;
            border: none; cursor: pointer;
            letter-spacing: 0.1rem; font-size: 1.4rem;
            font-family: 'Montserrat', sans-serif;
            transition: background-color 0.3s ease;
            text-decoration: none;
            text-align: center;
            line-height: 45px;
            box-sizing: border-box;
          }
          .ci-pop__cta:hover { background-color: #b55c3d; color: #ffffff; }
          .ci-pop__cta:focus { outline: 2px solid #C66E4E; }
        `;
        const style = document.createElement('style');
        style.id = 'ci-backorder-popup-styles';
        style.textContent = css;
        document.head.appendChild(style);
      }

      const message = submitBtn.dataset.backorderMessage ||
        "This item is currently unavailable for your quantity. We may have it on backorder or can produce it with a lead time — email us to explore options!";

      const overlay = document.createElement('div');
      overlay.className = 'ci-pop-overlay';
      overlay.id = 'ci-backorder-popup';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'ci-pop-title');
      overlay.innerHTML = `
        <div class="ci-pop">
          <button class="ci-pop__x" id="ci-pop-close-x" aria-label="Close">&times;</button>
          <div class="ci-pop__label">
            <span class="ci-pop__dot"></span>
            On backorder
          </div>
          <p class="ci-pop__message" id="ci-pop-title">${message}</p>
          <a href="mailto:order@clayimports.com"
             class="ci-pop__cta"
             id="ci-pop-close-cta">EMAIL US</a>
        </div>
      `;
      document.body.appendChild(overlay);

      const close = () => {
        overlay.classList.add('is-closing');
        setTimeout(() => {
          overlay.classList.remove('is-open', 'is-closing');
          document.body.style.overflow = '';
        }, 360);
        submitBtn?.focus();
      };

      overlay.querySelector('#ci-pop-close-x').addEventListener('click', close);
      overlay.querySelector('#ci-pop-close-cta').addEventListener('click', () => setTimeout(close, 200));
      overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
      document.addEventListener('keydown', (e) => {
        if (overlay.classList.contains('is-open') &&
            (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          close();
        }
      });
    }

    function openBackorderModal() {
      ensureBackorderModal();
      const overlay = document.getElementById('ci-backorder-popup');
      overlay.classList.remove('is-closing');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      overlay.querySelector('#ci-pop-close-cta').focus();
    }

    // ──  BACKORDER LOGIC ───────────────────────────────────────────────────

    function isBackorderVendor() {
      const vendor = window.productData?.vendor
                  || window.calProductVariant?.vendor
                  || '';
      return backorderVendors.includes(vendor);
    }

    function checkBackorder(triggerModal = false) {
      if (!isBackorderVendor()) return;

      const inventoryPolicy = submitBtn.dataset.inventoryPolicy;
      const inventoryQty    = parseInt(
        submitBtn.dataset.inventoryQuantity ??
        submitBtn.dataset.remainingInventory ??
        '0'
      );

      const requestedQty = parseInt(qtyInput?.value || '0');

      const isBackorder = (
        inventoryPolicy === 'deny' &&
        (requestedQty > inventoryQty || inventoryQty <= 0)
      );

      if (isBackorder) {
        labelSpan.textContent = 'ON BACKORDER';
        submitBtn.disabled = false;
        submitBtn.removeAttribute('disabled');
        submitBtn.setAttribute('aria-disabled', 'false');
        submitBtn.classList.remove('disabled', 'is-disabled');
        submitBtn.style.pointerEvents = 'auto';
        submitBtn.style.opacity = '1';

        if (triggerModal) openBackorderModal();

        submitBtn.onclick = (e) => {
          e.preventDefault();
          openBackorderModal();
        };
      } else {
        if (labelSpan.textContent === 'ON BACKORDER') {
          labelSpan.textContent = 'ADD TO CART';
        }
        submitBtn.onclick = null;
      }
    }

    // ── OBSERVERS ─────────────────────────────────────────────────────────

    if (sqftInput) {
      sqftInput.addEventListener('input', () => {
        setTimeout(() => checkBackorder(true), 150);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', () => checkBackorder(true));
      new MutationObserver(() => checkBackorder(true))
        .observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
    }

    if (variantInput) {
      variantInput.addEventListener('change', () => setTimeout(() => checkBackorder(false), 100));
      new MutationObserver(() => checkBackorder(false))
        .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    document.addEventListener('backorderCheck', () => checkBackorder(false));

    new MutationObserver(() => checkBackorder(false))
      .observe(submitBtn, { attributes: true, attributeFilter: ['data-inventory-quantity', 'data-inventory-policy'] });

    setTimeout(() => checkBackorder(false), 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 400));
  } else {
    setTimeout(init, 400);
  }
})();